import { useState } from 'react';
import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import Button from '@/design_system/Button';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconUserMail from '@/icons/UserMail.svg';
import { useActivities } from '@/models/request';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { formatDate } from '@/utils/date';

import { RecordClientContactDialog } from '../../ArticleActions/shared/RecordClientContactDialog';
import { BaseMessageDetailedContent } from '../BaseMessage';

export const RecordClientContactMessage = () => {
  const { request, article } = useArticleContext();

  const [isOpen, setIsOpen] = useState(false);

  const { data: { activities } = { activities: [] } } = useActivities({
    requestId: request.id,
    types: ['client_contact_recorded'],
  });

  const latestActivity = activities?.filter(
    (activity) => activity.data?.step === article.step?.step
  )?.[0];

  return (
    <>
      <Button variant="secondary" onPress={() => setIsOpen(true)}>
        <IconUserMail />
        {latestActivity ? (
          <Trans id="request.record-client-contact.button">Record follow-up</Trans>
        ) : (
          <Trans id="request.record-client-contact.button.first">Record client outreach</Trans>
        )}
      </Button>
      <RecordClientContactDialog isOpen={isOpen} setIsOpen={setIsOpen} />
      {!!latestActivity && <LatestActivityData activity={latestActivity} />}
    </>
  );
};

const LatestActivityData = ({
  activity,
}: {
  activity: ActivityOfType<'client_contact_recorded'>;
}) => {
  const { article } = useArticleContext();

  const date = formatDate(new Date(activity.createdAt), { dateStyle: 'medium' });

  const contactName = activity.data?.salesAdvisor
    ? `${activity.creator.name} (${activity.data.salesAdvisor})`
    : activity.creator.name;

  return (
    <>
      <Paragraph size="200" color="secondary">
        <Trans id="request.record-client-contact.latest">
          Latest contact recorded on {date} by {contactName}
        </Trans>
      </Paragraph>
      {!!activity.data?.additionalInformation && (
        <BaseMessageDetailedContent article={article}>
          <Paragraph size="200" color="secondary">
            {activity.data?.additionalInformation}
          </Paragraph>
        </BaseMessageDetailedContent>
      )}
    </>
  );
};
